import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/attendance/class_count_chart/"
});

export const api = {
  getFilters(params) {
    return instance.post("filters", params);
  },
  getChart(params) {
    return instance.post("", params);
  }
};
